// import mpro from './mpro';

// Save the temp array and clear it
const tempArray = window.mpro || null;

// Reset the global mpro object
// @ts-ignore
window.mpro = {};

export default tempArray;
